import React from 'react'

export const CourseSideMenuSkeleton = () => (
  <div
    className={`h-[calc(80vh)] w-full animate-pulse rounded-md bg-THEME-disabled lg:w-[330px]`}
  />
)
